import { UserRoleUI } from "../contexts/AuthContext";

export type DefaultAuthRoute =
  | "Admin Dashboard"
  | "Admin Companion Dashboard"
  | "Faculty Companion Dashboard"
  | "Companion Home"
  | "Home";

export const getDefaultAuthenticatedRoute = ({
  userRole,
  isCompanionMode,
}: {
  userRole: UserRoleUI;
  isCompanionMode: boolean;
}): DefaultAuthRoute => {
  // Students
  if (userRole === UserRoleUI.STUDENT) {
    return isCompanionMode ? "Companion Home" : "Home";
  }

  // Non-students
  if (!isCompanionMode) {
    return "Admin Dashboard";
  }

  // Companion mode (non-students)
  return userRole === UserRoleUI.FACULTY ? "Faculty Companion Dashboard" : "Admin Companion Dashboard";
};
